import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * Skeleton component for payment cards in HomeScreen
 * Matches the structure and dimensions of payment cards
 */
export function PaymentCardSkeleton() {
    const colors = useUIColors();

    return (
        <View style={[styles.card, { backgroundColor: colors.backgroundLevel1 }]}>
            <View style={styles.content}>
                <Skeleton width={120} height={12} />
                <View style={styles.amountContainer}>
                    <Skeleton width={15} height={15} variant="circular" />
                    <Skeleton width={80} height={14} style={{ marginLeft: 4 }} />
                </View>
                <Skeleton width={100} height={12} />
            </View>
            <Skeleton width={18} height={18} variant="circular" />
        </View>
    );
}

const styles = StyleSheet.create({
    card: {
        borderRadius: 12,
        padding: 12,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
    },
    content: {
        flex: 1,
        gap: 8,
    },
    amountContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});

export default PaymentCardSkeleton;

